<template>
  <v-container>
    <v-layout
      align-center
      :style="{ backgroundImage: 'url(/images/home-banner.png)' }"
      class="general-slide"
      row
      wrap
    >
      <v-container class="pa-2">
        <v-row class="fill-height">
          <v-col
            cols="8"
            lg="6"
            md="5"
            class="right-fade-bg d-flex justify-center align-center"
          >
            <div>
              <h1 class="mb-2 text-h2">
                {{ pkg.project }}
              </h1>
              <p class="text-h4 my-6">
                {{ t('home.line_1') }}
              </p>
              <v-btn
                size="x-large"
                elevation="2"
                color="primary"
                class="mt-6"
                to="/sign-in"
              >
                {{ t('home.start_btn') }}
              </v-btn>
            </div>
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

import pkg from '../../../package.json';

const {t} = useI18n();
</script>

<script lang="ts">
export default {
  name: 'Home',
};
</script>